/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { CostCenterFinderBusinessService } from '../resources/cost-center-finder-business.service';
import { CostCenterFinderDialogComponent } from './cost-center-finder-dialog.component';

export const costCenterFinderDialogRoute = createDialogRoute({
  component: CostCenterFinderDialogComponent,
  init: CostCenterFinderBusinessService,
});
